import { cardClass } from '@ledgerloom/ui';
import { usePageTitle } from '../hooks';
import { HelpChat } from '../components/HelpChat';

// Help (docs/plans/help-agent-plan.md): the help agent's chat on a page of its
// own, for phones and links; the Help button opens the same chat over any screen.
// It answers from the Mazu guide and what you may see of the workspace,
// and changes nothing. Patterns: ai-intelligence/ai-chat, ai-intelligence/ai-loading-states.
export function Help() {
  usePageTitle('Help');
  return (
    <div className="stack">
      <div>
        <h1>Help</h1>
        <p className="muted" style={{ margin: 0 }}>Ask anything about Mazu: what a screen is for, what a word means, how to do something, or why something is missing.</p>
      </div>
      <div className={`${cardClass} card-pad`}>
        <HelpChat level={2} />
      </div>
    </div>
  );
}
